import React from 'react';
import PropTypes from 'prop-types';
import { FormWrapper, TargetStatus } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';

import s from './styles.module.scss';

const DeviceStatusInfo = ({ deviceStatus, notes, recommendations, t }) => (
  <FormWrapper title={t('patient.deviceStatus')} data-test="deviceStatusInfo">
    <p>
      <strong>{t('reports.reviewedByClinicianMessage')}</strong>
    </p>
    <div className={s.deviceStatus}>
      <div className={s.deviceStatusIndicator}>
        <TargetStatus variant={deviceStatus} />
      </div>
      <div className={s.deviceStatusContent}>{notes}</div>
    </div>
    {recommendations && (
      <div className={s.recommendation}>
        <strong>{t('reports.recommendationsForPhysician')}:</strong> {recommendations}
      </div>
    )}
  </FormWrapper>
);

DeviceStatusInfo.defaultProps = {
  recommendations: null,
};

DeviceStatusInfo.propTypes = {
  deviceStatus: PropTypes.oneOf(['danger', 'warning', 'success']).isRequired,
  notes: PropTypes.string.isRequired,
  recommendations: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(DeviceStatusInfo);
